<script>
  import { onMount } from "svelte";
  import Navigation from "./Navigation.svelte";
  import Details from "./Details.svelte";
  import { birthData } from "../stores/birthData.js";
  const apiUrl = "https://astro.astrosofica.nl/php/";
  import { pGlyph, sGlyph } from '../stores/glyph.js';
  import { makeReadable, decodeHtml } from '../utils/utils.js';

  // Use the $ sign to create reactive variables
  $: longitude = $birthData.longitude;
  $: latitude = $birthData.latitude;
  $: utcTime = $birthData.utcTime;
  $: utcDateStr = $birthData.utcDateStr;
/*
  const planet= [
    "Zon", "Maan", "Mercurius", "Venus", "Mars", "Jupiter", "Saturnus", "Uranus", "Neptunus", "Pluto", "Noordknoop", "Ascendant", "Midhemel"
  ]
*/
  // retreive data from the API
  let curProgression = [];
  async function getProgression(utcDateStr, utcTime, longitude, latitude) {
  const response = await fetch(`${apiUrl}prog-current.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      date: utcDateStr,
      utc: utcTime,
      long: longitude,
      lat: latitude,
    }),
  });
  const data = await response.json();
  if (!Array.isArray(data)) {
    throw new Error('Invalid API response'); // bad practice, need to implement error handling
  }
  return data;
}

  // find out if the data is already loaded, if not, load it
  async function loadData() {
  if (
    utcDateStr &&
    utcTime &&
    longitude &&
    latitude &&
    (!curProgression || !curProgression.length)
  ) {
    const newProgression = await getProgression(utcDateStr, utcTime, longitude, latitude);
    if (newProgression) {
      curProgression = newProgression;
    } else {
      console.error('Failed to load progression data'); // bad practice, need to implement error handling
    }
  }
}
  // load data on mount
  onMount(async () => {
    await loadData();
  });
  // determine if curProgression has data
  $: hasData = curProgression.length > 0;

  // Helper functions
  function dateNow() {
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  function direction(snel){
    if (snel > 0) {
      return "D";
    } else if (snel < 0) {
      return "R";
    } else {
      return "S";
    }
  }
  </script>

  <div class="container">
  <Navigation />
  <Details />
  <h3>Progressies op {dateNow()}</h3>
  {#if hasData}
  <table>
    <thead>
      <tr>
        <th>Planeet</th>
        <th></th>
        <th>Positie</th>
        <th>Huis</th>
      </tr>
    </thead>
    <tbody>
      {#each curProgression as progression}
      <tr>
        <td class="planeet astro-font">{@html pGlyph[progression.planet]}</td>
        <td align="right">{direction(progression.speed)}</td>
        <td>{@html makeReadable(progression.pos, sGlyph)}</td>
        <td>staat in huis {progression.house}</td>
      </tr>
      {/each}
    </tbody>
  </table>
  {:else}
  <p>Geen progressies gevonden</p>
  {/if}


  
  
</div>